import { useState } from 'react';
import Header from './components/common/Header';
import Sidebar from './components/common/Sidebar';

export default function Layout({ children }) {
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  return (
    <div className="flex h-screen overflow-hidden">
      <Sidebar
        isOpen={mobileSidebarOpen}
        setIsOpen={setMobileSidebarOpen}
        collapsed={sidebarCollapsed}
        toggleCollapse={() => setSidebarCollapsed(!sidebarCollapsed)}
      />
      <div className="flex flex-col flex-1 overflow-hidden">
        <Header
          toggleMobileSidebar={() => setMobileSidebarOpen(!mobileSidebarOpen)}
          collapsed={sidebarCollapsed}
          toggleCollapse={() => setSidebarCollapsed(!sidebarCollapsed)}
        />
        <main className="flex-1 pr-0 p-3 lg:pr-0 lg:p-3 overflow-y-auto">{children}</main>
      </div>
    </div>
  );
}
